import type { ReactNode } from "react"
import React from "react"

import { cn } from "@productlane/lib/src/browser"

import { HowItWorksButton } from "./settings-switches/how-it-works-button"

interface SettingsHeaderProps {
	title: string
	titlePrefix?: ReactNode
	titleSuffix?: ReactNode
	subtitle?: string | ReactNode
	subtitleClassName?: string
	docsArticle?: string
	action?: ReactNode
	className?: string
	onTitleClick?: () => void
}

export const SettingsHeader = React.memo(
	({
		title,
		subtitle,
		subtitleClassName,
		docsArticle,
		action,
		titlePrefix,
		titleSuffix,
		className,
		onTitleClick,
	}: SettingsHeaderProps) => {
		const docsLink = docsArticle ? (
			<HowItWorksButton article={docsArticle} variant="link" />
		) : null

		return (
			<div
				className={cn(
					"mb-8 flex w-full select-none flex-wrap items-center justify-between",
					className,
				)}
			>
				<div className="flex w-full items-center justify-between gap-2 max-sm:flex-col max-sm:items-start">
					<div className="flex w-full flex-col gap-2">
						<div className="flex items-center gap-2">
							{titlePrefix}
							<h1 className="mr-2 truncate text-3xl font-medium">
								{onTitleClick ? (
									<button
										type="button"
										onClick={onTitleClick}
										className="cursor-default truncate rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-300 dark:focus-visible:ring-gray-600"
									>
										{title}
									</button>
								) : (
									title
								)}
							</h1>
							{titleSuffix}
						</div>
						{typeof subtitle === "string" || !subtitle ? (
							!subtitle && !docsLink ? null : (
								<div
									className={cn(
										"text-sm tracking-tight text-secondary",
										subtitleClassName,
									)}
								>
									{subtitle}
									{subtitle && docsLink ? " " : null}
									{docsLink}
								</div>
							)
						) : (
							<>
								{subtitle}
								{docsLink}
							</>
						)}
					</div>

					<div className="flex-none">{action}</div>
				</div>
			</div>
		)
	},
)
